import { CHAIN_IDS } from "../../core/constants";

/**
 * @docs https://docs.tempo.xyz/protocol/fees/spec-fee-amm#2-feemanager-contract
 */
export const TEMPO_FEE_MANAGER_ADDRESS =
  "0xfeec000000000000000000000000000000000000" as const;

export const feeManagerAbi = [
  {
    name: "userTokens",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "address", name: "user" }],
    outputs: [{ type: "address" }],
  },
] as const;

export const isTempoChain = (chainId: string | undefined): boolean =>
  chainId === CHAIN_IDS.TEMPO;

/**
 * Convert a gas fee amount from 18 decimals (attodollars)
 * to 6-decimal TIP-20 stablecoin units (microdollars).
 * All TIP-20 tokens on Tempo have 6 decimals.
 * @docs https://docs.tempo.xyz/protocol/fees/spec-fee#fee-units
 */
export const convertTempoFeeToStablecoinUnits = (feeIn18Dec: bigint): bigint =>
  feeIn18Dec / BigInt(10 ** 12);

export type TempoFeeData = {
  gasBalance: bigint;
  /**
   * The address of the resolved gas token.
   * Either the account-preferred token address or the fromToken address.
   */
  gasTokenAddress: string;
};

export type ChainFeeParams = {
  fromTokenPaysGasFees: boolean;
  gasTokenBalanceWei: bigint;
  /**
   * Converts a raw fee (from gas estimator)
   * into the correct unit for the resolved gas token.
   * Handles the 18-dec to 6-dec conversion for Tempo.
   */
  normalizeFee: (rawFee: bigint) => bigint;
};
